// ======================================================================
// FILE:
// src/modules/expense_management/claims/components/BusinessReferenceLookupDialog.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// Business Reference Lookup Dialog
// ======================================================================

import React from "react";
import { Modal } from "react-bootstrap";

export default function BusinessReferenceLookupDialog({

    show = false,

    loading = false,

    title = "Business Reference Lookup",

    searchText = "",

    onSearchTextChange,

    onSearch,

    rows = [],

    columns = [],

    onSelect,

    onClose,

}) {

    return (

        <Modal
            show={show}
            onHide={onClose}
            size="xl"
            backdrop="static"
            centered
        >

            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <Modal.Header closeButton>

                <Modal.Title>

                    <i className="fas fa-search me-2" />

                    {title}

                </Modal.Title>

            </Modal.Header>

            {/* ====================================================== */}
            {/* BODY */}
            {/* ====================================================== */}

            <Modal.Body>

                <div className="row mb-3">

                    <div className="col-md-10">

                        <input

                            type="text"

                            className="form-control"

                            placeholder="Search by Reference Number, Customer, Ticket, Visit, Contact..."

                            value={searchText}

                            onChange={(e) =>

                                onSearchTextChange?.(
                                    e.target.value
                                )

                            }

                        />

                    </div>

                    <div className="col-md-2 d-grid">

                        <button

                            className="btn btn-primary"

                            onClick={onSearch}

                        >

                            <i className="fas fa-search me-1" />

                            Search

                        </button>

                    </div>

                </div>
                                {/* ====================================================== */}
                {/* RESULTS */}
                {/* ====================================================== */}

                <div className="table-responsive">

                    <table className="table table-hover table-bordered align-middle">

                        <thead className="table-light">

                            <tr>

                                {

                                    columns.map((column) => (

                                        <th
                                            key={column.field}
                                        >

                                            {column.title}

                                        </th>

                                    ))

                                }

                                <th
                                    style={{ width: 120 }}
                                >

                                    Action

                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {

                                loading ? (

                                    <tr>

                                        <td
                                            colSpan={
                                                columns.length + 1
                                            }
                                            className="text-center py-5"
                                        >

                                            <div
                                                className="spinner-border spinner-border-sm me-2"
                                            />

                                            Loading...

                                        </td>

                                    </tr>

                                ) : rows.length === 0 ? (

                                    <tr>

                                        <td
                                            colSpan={
                                                columns.length + 1
                                            }
                                            className="text-center text-muted py-5"
                                        >

                                            No records found.

                                        </td>

                                    </tr>

                                ) : (

                                    rows.map((row, index) => (

                                        <tr
                                            key={
                                                row.reference_id ||
                                                row.id ||
                                                index
                                            }
                                        >

                                            {

                                                columns.map((column) => (

                                                    <td
                                                        key={column.field}
                                                    >

                                                        {

                                                            row[
                                                                column.field
                                                            ] ?? "-"

                                                        }

                                                    </td>

                                                ))

                                            }

                                            <td>

                                                <button

                                                    type="button"

                                                    className="btn btn-success btn-sm"

                                                    onClick={() =>
                                                        onSelect?.(
                                                            row
                                                        )
                                                    }

                                                >

                                                    Select

                                                </button>

                                            </td>

                                        </tr>

                                    ))

                                )

                            }

                        </tbody>

                    </table>

                </div>
                                {/* ====================================================== */}
                {/* PAGINATION PLACEHOLDER */}
                {/* ====================================================== */}

                <div className="d-flex justify-content-between align-items-center mt-3">

                    <div className="text-muted small">

                        Results: {rows.length}

                    </div>

                    <div>

                        {/* Pagination will be added during API integration */}

                    </div>

                </div>

            </Modal.Body>

            {/* ====================================================== */}
            {/* FOOTER */}
            {/* ====================================================== */}

            <Modal.Footer>

                <button

                    type="button"

                    className="btn btn-secondary"

                    onClick={onClose}

                >

                    <i className="fas fa-times me-1" />

                    Close

                </button>

            </Modal.Footer>

        </Modal>

    );

}